import { configureEtracker } from './etracker'
import { configureHistory } from './history'
import { configureHoneybadger } from './honeybadger'
import { configureObjClassForContentType } from './objClassForContentType'
import { configureScrivito } from './scrivito'
import { configureScrivitoContentBrowser } from './scrivitoContentBrowser'
import { configureWindowScrivito } from './windowScrivito'

export function configure() {
  configureScrivito()

  configureObjClassForContentType()
  configureScrivitoContentBrowser()
  configureHistory()
  configureHoneybadger()
  configureEtracker()
  configureWindowScrivito()
}
